export type SessionStorageKey = string; // 具体的なキー名があればここで列挙
export type LocalStorageKey = 'hitzItems'; // | 'anything_else...'

// Session Storageに値を設定
export const setSessionStorageItem = <T>(key: SessionStorageKey, value: T): void => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

// Session Storageから値を取得
export const getSessionStorageItem = <T>(key: SessionStorageKey): T | null => {
  const item = sessionStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

// Local Storageに値を設定
export const setLocalStorageItem = <T>(key: LocalStorageKey, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

// Local Storageから値を取得
export const getLocalStorageItem = <T>(key: LocalStorageKey): T | null => {
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};

// Local Storageから値を取得
export const removeLocalStorageItem = (key: LocalStorageKey): void => {
  localStorage.removeItem(key);
};

// Local Storageから値を取得
export const getLocalStorageObject = (key: LocalStorageKey): string | null => {
  const item = localStorage.getItem(key);
  return item;
};
